import Swal from "sweetalert2";
import { ModuleName, AxInit } from "../../Lib/AxSystem/AxInit";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxReloadable } from "../../Lib/AxSystem/AxReloadable";
import { AxDropdown, AxFormValidation } from "@axess/limestone";

@ModuleName("Invoice")
export class Invoice implements AxInit, AxReloadable {
    constructor(private _i18nHelper = new I18nHelper(),
        private axLoading = new AxLoading()) { }

    private _CountryDropDown: AxDropdown = new AxDropdown();

    AxInit(init?: any): void {
        this.InitClickEvents();
        this.InitValidator();
        this.InitDropDown();
    }

    AxReload(parentName: string): void {
        this.InitClickEvents();
        this.InitValidator();
        this.InitDropDown();
    }

    InitValidator(): void {
        new AxFormValidation({
            selector: '#fiscal_information',
            rules: this.getValidationRules(),
            callback: (form: HTMLElement) => {
                this.prepareDocument(form);
            }
        }).init();
    }

    InitDropDown(): void {
        this._CountryDropDown.init('.invoice__country', {
            searchBar: false,
            multiSelect: false,
            onSelect: (x, y) => {
                $('#fiscal_country').val(y);
            }
        });
    }

    InitClickEvents(): void {
        $('#invoice-modal [data-close-invoice-modal]').on('click', (x => {
            const $modal = $('#invoice-modal');

            $modal.removeClass('is-open');
        }));

        $('[data-invoice-modal-open]').on('click', (x => {
            x.preventDefault()
            const url = '/Invoice/ReadyToInvoicePdf';
            const orderNr = parseInt(x.currentTarget.getAttribute('data-invoice-orderNr'))
            const accountNr = parseInt(x.currentTarget.getAttribute('data-invoice-accountNr'))
            const data = {
                orderNr,
                accountNr
            }
            AxessViewer.loadPartialView(url, data, (res) => {
                if (res.ready) {
                    $('#fiscal_shopping_cart_order').val(orderNr);
                    $('#fiscal_shopping_cart_customer').val(accountNr);
                    $('#invoice-modal').addClass('is-open');
                } else {
                    Swal.fire({
                        title: this._i18nHelper.GetTranslation(Translations.Warning),
                        html: res.message,
                        icon: 'info',
                        customClass: {
                            closeButton: 'btn btn-secondary',
                            confirmButton: 'btn btn-primary',
                        },
                        confirmButtonText: this._i18nHelper.GetTranslation(Translations.Ok),
                    })
                }
            }, {silent: true});
        }));

        $('[data-invoice-retry-document]').on('click', (x => {
            x.preventDefault()
            const url = '/Invoice/RetryInvoicePdf';
            const orderNr = parseInt(x.currentTarget.getAttribute('data-invoice-orderNr'))
            const accountNr = parseInt(x.currentTarget.getAttribute('data-invoice-accountNr'))
            const data = {
                orderNr,
                accountNr
            }
            AxessViewer.loadPartialView(url, data, (res) => {
                if (res.success) {
                    $('[data-invoice-retry-document]').addClass("d-none")
                    $('[data-invoice-link]').attr('href', res.url).removeClass("d-none");
                    window.open(res.url, '_blank').focus();
                } else {
                    Swal.fire({
                        title: this._i18nHelper.GetTranslation(Translations.Error),
                        html: res.message,
                        icon: 'error',
                        customClass: {
                            closeButton: 'btn btn-secondary',
                            confirmButton: 'btn btn-primary',
                        },
                        confirmButtonText: this._i18nHelper.GetTranslation(Translations.Ok),
                    })
                }
            }, { silent: true });
        }));
    }

    prepareDocument(form: HTMLElement) {
        const url = '/Invoice/CreateInvoicePdf';
        this.axLoading.ShowLoadingIndicator($('[data-invoice-loader]')?.get(0));
        const invoiceForm = {
            Name: $('#fiscal_name').val(),
            TaxId: $('#fiscal_id').val(),
            Address: $('#fiscal_address').val(),
            City: $('#fiscal_city').val(),
            ZipCode: $('#fiscal_zip').val(),
            Country: $('#fiscal_country').val(),
            State: $('#fiscal_state').val(),
            OrderNr: $('#fiscal_shopping_cart_order').val(),
            AccountNr: $('#fiscal_shopping_cart_customer').val(),
        }
        AxessViewer.loadPartialView(url, JSON.stringify(invoiceForm), (res) => {
            this.axLoading.HideLoadingIndicator($('[data-invoice-loader]')?.get(0));
            this.cleanModal();
            const $modal = $('#invoice-modal');
            $modal.removeClass('is-open');
            if (res.success) {
                $('[data-invoice-modal-open]').addClass("d-none");
                $('[data-invoice-link]').attr('href', res.url).removeClass("d-none");
                window.open(res.url, '_blank').focus();
            } else {
                $('[data-invoice-modal-open]').addClass("d-none");
                $('[data-invoice-retry-document]').removeClass("d-none")
                Swal.fire({
                    title: this._i18nHelper.GetTranslation(Translations.Error),
                    html: res.message,
                    icon: 'error',
                    customClass: {
                        closeButton: 'btn btn-secondary',
                        confirmButton: 'btn btn-primary',
                    },
                    confirmButtonText: this._i18nHelper.GetTranslation(Translations.Ok),
                })
            }
        }, { contentType: 'application/json' });
    }

    cleanModal(): void {
        $('#fiscal_name').val('');
        $('#fiscal_id').val('');
        $('#fiscal_address').val('');
        $('#fiscal_city').val('');
        $('#fiscal_zip').val('');
        $('#fiscal_state').val('');
    }

    getValidationRules(): JQueryValidation.RulesDictionary {
        return {
            fiscal_name: {
                required: true,
            },
            fiscal_id: {
                required: true,
            },
            fiscal_address: {
                required: true,
            },
            fiscal_zip: {
                required: true,
            },
            fiscal_country: {
                required: true,
            },
        };
    }
}

interface InvoiceFormMode {
    Name: string,
    TaxId: string,
    Address: string,
    City: string,
    ZipCode: string,
    Country: string,
    State: string,
    ShoppingCartId: string,
}